import CardCommon from '../CardCommon';

export default function CardA() {
    return (
        <>
            <CardCommon
                pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1716172173877/v1.mp4"
                isVideo={true}
                subTitle="Automatic seasonal savings"
                title="Always on track of Time-of-Use (TOU) Rates"
                desc="Maximize savings year-round with the EcoFlow DELTA Pro Ultra. This Time-Of-Use-optimized system connects to local utilities to automatically leverage off-peak rates and adjust for seasonal changes, ensuring consistent savings without the need to track peak hours."
            />
        </>
    );
}
